@if (prices().length > 0) {
  <strong class="from">
    {{ 'productDetails.labelFrom' | transloco }}
  </strong>
  <span class="vat-label">({{ vatLabel() | transloco }})</span>

  @for (price of prices(); track $index) {
    <span class="unit-name-{{ $index }}">
      {{ price.unitName }}
      @if (price.unit === 'PIECES') {
        <fa-icon
          [icon]="faCircleInfo"
          [ngbTooltip]="'productDetails.perPieceTooltip' | transloco"
          [tooltipClass]="'ngb-boels-tooltip'"
          [autoClose]="'inside'"
          data-boundary="viewport"
          tabindex="0"
          role="button"
        ></fa-icon>
      }
    </span>
    <strong class="price-{{ $index }}">{{ price.formattedValue }}</strong>
  }
} @else {
  @if (type() === 'main') {
    <p class="product-price__price-on-application">
      {{ 'productDetails.labelPriceOnApplication' | transloco }}
    </p>
  }
}
